export default "__VITE_ASSET___QE8VdIh__"